import React from "react";
import { MessageCircle } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { SIX_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createCsm, createCsmVersion, getCsmAssets, updateCsmMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-032 (EMAILS-SPEC-017/017B): CTA Support Microcopy authoring.
// Same 6-state lifecycle vocabulary and eligibility gate as P.S. -- see
// CRE-SPEC-001 §14.5/§15.10 and ASSET-001 Version 1.4.0.
const config = {
  familyCode: "CSM",
  testIdPrefix: "csm",
  idField: "csm_id",
  contentField: "canonical_csm",
  contentLabel: "Canonical CTA Support Microcopy",
  contentInputType: "textarea",
  contentPlaceholder: "e.g. No obligation. No pressure. Just an estimate.",
  labelSingular: "CTA Support Microcopy",
  labelPlural: "CTA Support Microcopy",
  icon: MessageCircle,
  statusValues: SIX_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable CTA Support Microcopy line (CSM####).",
  api: {
    list: getCsmAssets,
    create: ({ name, status, content }) => createCsm({ name, status, canonicalCsm: content }),
    createVersion: (id, { version, content }) => createCsmVersion(id, { version, canonicalCsm: content }),
    updateMetadata: (id, { name, status }) => updateCsmMetadata(id, { name, status }),
  },
};

export default function CsmPanel() {
  return <AssetFamilyPanel config={config} />;
}
